import React from 'react';
import FilterBlock from './Common/filterBlock';
import SearchInput from './Common/searchInput';
import LayoutRightBlock from './layoutRightBlock';

const FilterLayoutSort = ({
  selectedCategory,
  handleCategorySelect,
  searchQuery,
  handleSearch,
  biggerLayout,
  handleSort,
  changeLayout,
}) => {
  return (
    <div className='upper-layout'>
      <FilterBlock
        currentCategory={selectedCategory}
        changeCategory={handleCategorySelect}
      />

      <SearchInput value={searchQuery} updateSearch={handleSearch} />

      <LayoutRightBlock
        currentLayout={biggerLayout}
        handleSorting={handleSort}
        handleLayout={changeLayout}
      />
    </div>
  );
};

export default FilterLayoutSort;
